import * as R from 'ramda';
import controller from './customer-service-acceptance-dialog.controller';
import template from './customer-service-acceptance-dialog.html';


let _orgDataService;
let _ssDialogService;
let _userService;

export default class customerServiceAcceptanceService {
  constructor(
    orgDataService,
    ssDialogService,
    userService
  ) {
    _orgDataService = orgDataService;
    _ssDialogService = ssDialogService;
    _userService = userService;
  }

  show(serviceId, acceptedCallback, cancelCallback) {
    return _userService.getUser().then(user => _orgDataService.getCSAText(serviceId)
      .then((getCSATextResponse) => {
        console.log(getCSATextResponse);
        const serviceEula = R.find(
          R.propEq('serviceId', serviceId),
          user.servicesEula
        );

        serviceEula.eulaText = getCSATextResponse.data.result[0].eulaText;
        _ssDialogService.dialogs.global.customerServiceAcceptance = _ssDialogService.alert(
          _getOptions({
            serviceEula,
            acceptedCallback,
            cancelCallback
          })
        );
        _ssDialogService.show(_ssDialogService.dialogs.global.customerServiceAcceptance);
      }));
  }

  hide() {
    _ssDialogService.hide(_ssDialogService.dialogs.global.customerServiceAcceptance);
  }
}

customerServiceAcceptanceService.$inject = [
  'orgDataService',
  'ssDialogService',
  'userService'
];


function _getOptions({ serviceEula = {}, acceptedCallback, cancelCallback }) {
  return {
    controller,
    controllerAs: 'customerServiceAcceptanceDialogVM',
    locals: {
      serviceEula,
      acceptedCallback,
      cancelCallback
    },
    escapeToClose: false,
    clickOutsideToClose: false,
    template,
  };
}
